const fetchData = (pageId: number): string => `
    {
    page(id: "${pageId}", idType: DATABASE_ID) {
      ServicesTemplate {
        titleServicesContact
      }
    }
  }
`;
export default fetchData;
